import { z } from 'zod'

import ZAction from '@/app/module/campaigns/types/schemas/actions/all-actions'

const ZOnRetriesExhausted = z.object({
  actions: z.array(ZAction).optional(),
})

export default ZOnRetriesExhausted
